<template>
  <div class="px-page mb-8">
    <div class="flex items-center justify-between">
      <h2 class="font-semibold text-xl leading-tight">
        QA | Overrides
      </h2>
      <a v-bind:href="$route('qa.overrides.create')" class="btn btn-primary btn-lg">
        New Override
      </a>
    </div>
  </div>

  <div class="card">
    <table class="table">
      <thead>
      <tr>
        <th>Keyword</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <template v-if="overrides.data.length" v-for="override in overrides.data">
        <tr>
          <td class="w-full max-w-0 text-gray-900 sm:w-auto sm:max-w-none">
            {{ override.keyword }}
          </td>
          <td class="text-right">
            <a v-bind:href="$route('qa.overrides.edit', override.id)" class="text-primary-500 hover:text-primary-700">Edit</a>
            <span> | </span>
            <a v-bind:href="$route('qa.overrides.destroy', override.id)" class="text-danger-500 hover:text-danger-700">Delete</a>
          </td>
        </tr>
      </template>
      <template v-else>
        <tr>
          <td colspan="5" class="text-center">No overrides exist</td>
        </tr>
      </template>
      </tbody>
    </table>

    <div class="card-footer">
      <Pagination v-bind:pagination="pagination" />
    </div>
  </div>
</template>

<script setup>
import Pagination from "../../../components/Pagination";

const { overrides } = defineProps(['overrides']);
const pagination = Object.assign({}, overrides);
delete pagination.data;
</script>
